export enum MenuItemKey {
  LEARNING_PATH = 'learning_path',
  CATALOG = 'catalog',
  EVENTS = 'events',
  CALENDAR = 'calendar',
  LIBRARY = 'library',
  COMMUNITY = 'community',
  SITEMAP = 'sitemap',
  ACHIEVEMENTS = 'achievements',
  LEADERBOARD = 'leaderboard',
  MANAGER_VIEW = 'manager-view',
  HELP = 'help',
  LEGAL_CENTER = 'legal-center',
  SWITCH_BRANCH = 'switch-branch',
  SEARCH = 'search',
  CHAT = 'chat',
  LANGUAGES  = 'languages',
  ADMIN_PANEL = 'admin-panel',
  USER = 'user',
  LOG_OUT = 'log-out',
  NOTIFICATIONS = 'notifications',
  HOME = 'home',
  PROFILE = 'profile',
  CERTIFICATES = 'certificates',
  COUPONS = 'coupons',
  GLOSSARY = 'glossary',
  CHALLENGES = 'challenges',
  WEBINARS = 'webinars',
  IN_PERSON_EVENTS = 'in-person-events',
  INSTA_LEARN = 'insta-learn',
  AI_CHAT = 'ai-chat',
  CONTENT = 'content'
}
